type GuidePageData = {
  title: string;
  description?: string[];
  anchor?: string;
  tabList?: GuidePageData[];
  screen?: string; // URL to the screenshot or video
};

const guidePage: GuidePageData[] = [
  {
    anchor: 'auth',
    title: 'Авторизация',
    description: [
      'Нажать на кнопку «Войти» в правом верхнем углу на главной странице сайта.',
      'В новом окне, войдите в учетную запись LESTA ID, используя почту и пароль, которые вы указываете при входе в игру.',
    ],
    screen: 'auth',
  },
  {
    anchor: 'file-location',
    title: 'Расположение файла',
    description: [
      'Загрузите реплей, перетащив файл в поле загрузки, обозначенное пунктиром. Либо нажмите на поле загрузки и выберите нужный реплей в открывшемся окне.',
      String.raw`Реплеи находятся в папке с игрой по пути С:\Games\Korabli\replays.`,
      'Вы можете загрузить реплей с версии игры 25.5 и выше.',
    ],
    screen: 'location',
  },
  {
    anchor: 'replay-info',
    title: 'Информация о реплее',
    description: [
      'Чтобы реплей было проще найти другим игрокам или чтобы принять участие в конкурсе, придумайте название и   описание, которые будут отражать  суть реплея. Так же рекомендуем вам задать теги из предложенных.',
    ],
    tabList: [
      {
        title: 'Название',
        description: [
          'Придумайте название для реплея и укажите его в поле «Название».',
          'Чтобы реплей проще было найти другим игрокам, название должно отражать суть реплея. Максимум 100 допустимых символов.',
          'Название не должно содержать мат и не должно нарушать Правила Игры.',
        ],
        screen: 'name',
      },
      {
        title: 'Описание',
        description: [
          'Добавьте краткое описание в поле «Описание», которое лучше всего отразит содержание боя из вашего реплея.',
          'Максимум 600 допустимых символов. Описание не должно содержать мат, ссылки, названия сторонних проектов схожей тематики, оскорбления в сторону компании и не должно нарушать Правила Игры.',
        ],
        screen: 'description',
      },
      {
        title: 'Теги',
        description: [
          'Чтобы реплей проще было найти другим игрокам или чтобы принять участие в конкурсе, добавьте «Теги реплея» из доступных.',
        ],
        screen: 'tags',
      },
    ],
  },
  {
    anchor: 'contests',
    title: 'Конкурсы',
    description: [
      'Чтобы принять участие в конкурсе, выберите конкурс в окне загрузке реплея. Вы можете участвовать в нескольких конкурсах, если реплей соответствует заявленным условиям. После обработки ваш реплей будет отображен на странице выбранного конкурса.',
    ],
    screen: 'contest',
  },
  {
    anchor: 'notification',
    title: 'Уведомление',
    description: [
      'При успешной загрузке в правом нижнем углу экрана появится уведомление, а в личном кабинете отобразится загруженный реплей.',
    ],
    screen: 'notification',
  },
];

const ruText = new Map<string, string>([
  ['meta-title-template', '%s | «Мир кораблей»'],
  ['home-meta-title', 'Реплеи'],
  ['home-title-new-replay', 'Новые реплеи'],
  ['home-title-actual', 'Актуальные видео'],
  ['home-title-social', 'Смотрите видео и стримы'],

  ['contest-index-title', 'Конкурсы реплеев'],
  ['contest-index-h1', 'Конкурсы'],
  ['contest-index-about-1', 'Участвуй в конкурсах и получай призы и признание других игроков!'],
  ['contest-index-about-2', 'Покажи свои навыки — докажи всем, что ты лучший!'],
  ['contest-index-soon', 'Скоро будет...'],
  [
    'contest-index-empty',
    'Пока что на странице тишина, но скоро мы порадуем вас новыми конкурсами.',
  ],

  ['contest-index-empty-active-h3', 'Сейчас нет активных конкурсов'],
  [
    'contest-index-empty-active-description',
    'На данный момент конкурсы отсутствуют, но мы уже работаем над чем-то интересным для вас.',
  ],

  ['contest-index-some-error', 'Что-то пошло не так, попробуйте перезагрузить страницу.'],

  ['contest-page-title', 'Конкурс'],
  ['contest-page-breadcrumbs', 'Все конкурсы'],
  ['contest-page-conditions', 'Условия'],
  ['contest-page-participants', 'Участники'],
  ['contest-page-disabled-caption', 'Пока здесь нет участников'],
  ['contest-page-link-join', 'Участвовать'],
  ['contest-page-link-to-forum', 'На форум'],
  ['contest-page-link-to-forum-end', 'Узнать победителей'],

  ['replay-page-share', 'Поделиться'],
  ['replay-page-copied', 'Скопировано'],

  ['replay-page-version', 'Версия'],
  ['replay-page-publish', 'Дата публикации'],
  ['replay-page-download', 'Скачать реплей'],

  ['replay-page-table-personal', 'Личный результат'],
  ['replay-page-table-teams', 'Командный результат'],
  ['replay-page-table-details', 'Подробный отчет'],

  ['replay-page-unfounded-ship', 'Неизвестный корабль'],

  ['component-personal-result-total', 'Получено за бой'],
  ['component-personal-result-efficiency', 'Боевая эффективность'],
  ['component-personal-result-start-time', 'Время начала боя'],

  ['component-contest-rules', 'Правила участия'],
  ['component-contest-label-FINISHED', 'Завершен'],
  ['component-contest-label-DEFAULT', 'Конкурс'],
  ['component-contest-label-NAVOEVAL', 'Навоевал'],

  ['component-contest-done', 'Завершен'],
  ['component-contest-start', 'До старта'],
  ['component-contest-end', 'До окончания'],

  ['widget-all-replays-btn-caption-roll', 'Свернуть'],
  ['widget-all-replays-btn-caption-expand', 'Смотреть еще'],
  ['widget-all-replays-btn-caption-load', 'Загружаю...'],

  ['upload-meta-title', 'Загрузить реплей'],
  ['upload-title', 'Загрузить реплей'],
  ['upload-how-to-upload', 'Как загрузить реплей?'],
  ['upload-button-label', 'Опубликовать'],
  ['upload-button-loading', 'Загружаем'],
  ['upload-button-change', 'Обновить'],
  ['upload-button-cancel', 'Отмена'],
  ['upload-file-caption', 'Выберите реплей'],
  ['upload-details-summary', 'Правила загрузки реплея'],
  ['upload-details-call-to-action', 'Скрыть'],
  [
    'upload-help-label',
    `Загрузка реплея возможна для актуальной версии игры и двух предыдущих.
    <br> ${String.raw`Файлы хранятся в папке с игрой. Пример: C:\Games\Korabli\replays`}`,
  ],
  ['upload-success-message', 'Реплей успешно загружен'],
  ['upload-edit-success-message', 'Изменения сохранены'],
  ['upload-failure-message', 'Ошибка загрузки'],
  [
    'upload-failure-details',
    'По техническим причинам реплей не может быть загружен. Повторите попытку через несколько минут.',
  ],

  ['upload-help-input-name-label', 'Название'],
  ['upload-help-input-name-placeholder', 'Добавьте название реплея'],

  ['upload-help-input-descr-label', 'Описание'],
  ['upload-help-input-descr-placeholder', 'Дайте короткое описание, которое отражает суть реплея'],

  ['upload-help-input-tag-label', 'Теги реплея'],
  ['upload-help-input-tag-placeholder', 'Добавьте до 10 тегов, чтобы реплей было проще найти'],

  ['upload-help-input-drop', 'Перетащите файл для загрузки или'],
  ['upload-help-input-drop-cta', 'выберите файл'],
  ['upload-help-input-drop-cta', 'выберите файл'],

  ['upload-help-input-contest-label', 'Участие в конкурсах'],
  ['upload-input-tags-noresults', 'По вашему запросу ничего не найдено.'],
  ['upload-input-tags-label', 'Добавьте до 10 тегов, чтобы реплей было проще найти'],
  ['upload-input-tags-max', 'Выбрано максимальное количество тегов'],

  ['edit-replay-title', 'Редактирование реплея'],

  ['all-replays-meta-title', 'Найти реплей'],

  ['component-dogtag-missing-required-field', 'Отсутствует обязательное поле'],
  ['component-dogtag-load-default-dogtag', 'Загружена нашивка по умолчанию'],

  ['component-dialog-title', 'Найти реплей'],
  ['component-dialog-close-title', 'Закрыть'],

  ['multiple-select-placeholder', 'Поиск'],
  ['guide-index-title', 'Как загрузить реплей'],

  ['account-page-title-no-found', 'На этой странице пока пусто'],
  ['account-page-description-no-found', 'Реплеи еще не загружены. '],

  ['error-message-unknown-error', 'Неизвестная ошибка'],
  ['error-message-permission-title', 'Действие недоступно'],
  ['error-message-permission-description', 'Недостаточно прав для выполнения операции'],
  ['success-message-copy-link', 'Ссылка на реплей скопирована'],
  ['replay-delete-state', '<p>Реплей удалён.</p><p>Просмотр больше недоступен</p>'],
  ['replay-delete', 'Реплей удалён. Просмотр больше недоступен'],
  ['warning-toast-unsupported-clipboard-feature-title', 'Не удалось скопировать ссылку'],
  ['warning-toast-unsupported-clipboard-feature-description', 'Копирование ограничено браузером'],

  ['toast-trouble-video-title', 'Ограничения обработки видео'],
  [
    'toast-trouble-video-description',
    'По техническим причинам загрузка и обработка видео может быть временно недоступна.',
  ],

  [
    'trouble-video-starting',
    'Уважаемые игроки, по техническим причинам загрузка ' +
    'и обработка видео может быть временно недоступна.',
  ],

  ['component-search-btn-find', 'Найти'],
  ['component-search-btn-cancel', 'Отменить'],
  ['component-search-filter-video', 'С видео'],
  ['component-search-filter-version', 'Текущая версия игры'],

  ['component-selected-filter-list-btn-clear', 'Сбросить всё'],
]);

const localisation: (entity: string) => (key: string) => string | undefined = (entity: string) => (key: string) => ruText.get(`${entity}-${key}`);

const uploadDetails: { title: string; description: string }[] = [
  {
    title: 'Требования к файлу',
    description:
      'Загрузка реплея возможна для актуальной версии игры и двух предыдущих. ' +
      'Формат загружаемого файла .korablireplay. Загружайте реплей спустя 10 минут после окончания боя.',
  },
  {
    title: 'Название и описание',
    description:
      'Название может содержать максимум 100 допустимых символов, а описание 600. ' +
      'Название и описание не должно содержать мат и должно отображать суть реплея. Описание не ' +
      'должно содержать ссылки, названия сторонних проектов схожей тематики, оскорбления в ' +
      'сторону компании.',
  },
  {
    title: 'Видео',
    description:
      'Обычно конвертация в видео может занять несколько дней. На данный момент,' +
      ' по техническим причинам, загрузка и обработка видео может быть временно недоступна.',
  },
  {
    title: 'Конкурсы',
    description:
      'Вы можете выбрать один или несколько конкурсов для участия. ' +
      'Реплей должен соответствовать правилам конкурса.',
  },
];

export { guidePage, localisation, ruText, uploadDetails };
